import { Agents } from "../../../../features/Agents";
import { AgentsPage } from "../../../../pages/AgentsPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const agentsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.krab.root,
  element: <AgentsPage />,
  name: "Агенты",
  children: appRouterPaths.krab.item
    ? [
        {
          path: appRouterPaths.krab.item,
          element: <Agents />,
          name: "Агент",
        },
      ]
    : undefined,
};
